import { styles } from "../styles";
import BackButton from "../components/BackButton";

const STATUS_META = {
  yellow: {
    label: "Caution",
    color: "#9a6b00",
    bg: "#fff3cd",
  },
  red: {
    label: "Disabled",
    color: "#c12c2c",
    bg: "#f8d7da",
  },
};

const formatDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString() : "—";

export default function EquipmentByStatusPage({
  status,
  equipment = [],
  customers = [],
  setSelectedCustomer,
  setSelectedLocation,
  setSelectedEquipment,
  setSelectedContactLocation,
  onBack,
}) {
  const meta = STATUS_META[status] || STATUS_META.yellow;
  const matches = equipment.filter((e) => (e.status || "green") === status);

  const goToEquipment = (e) => {
    const customer = customers.find((c) => c.id === e.customerId);
    const location = customer?.locations.find((l) => l.id === e.locationId);
    const realEquipment = location?.equipment.find((x) => x.id === e.id);
    if (!customer || !location || !realEquipment) return;
    setSelectedCustomer(customer);
    setSelectedLocation(location);
    setSelectedEquipment(realEquipment);
    if (setSelectedContactLocation) setSelectedContactLocation(null);
  };

  return (
    <>
      <BackButton onClick={onBack} />
      <h2 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        Equipment —
        <span
          style={{
            fontSize: "16px",
            padding: "4px 12px",
            borderRadius: "12px",
            background: meta.bg,
            color: meta.color,
            fontWeight: 700,
          }}
        >
          ● {meta.label}
        </span>
      </h2>

      {matches.length === 0 ? (
        <p style={{ color: "#666", fontStyle: "italic" }}>
          No equipment currently in {meta.label.toLowerCase()} status.
        </p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {matches
            .slice()
            .sort((a, b) =>
              (a.customerName || "").localeCompare(b.customerName || "")
            )
            .map((e) => (
              <li
                key={e.id}
                onClick={() => goToEquipment(e)}
                style={{
                  ...styles.card,
                  maxWidth: "780px",
                  cursor: "pointer",
                }}
                onMouseEnter={(ev) =>
                  (ev.currentTarget.style.background = "#f4f8ff")
                }
                onMouseLeave={(ev) =>
                  (ev.currentTarget.style.background = styles.card.background)
                }
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      background: meta.color,
                    }}
                  />
                  <strong>{e.type || "Equipment"}</strong>
                  {e.subType && (
                    <span style={{ fontSize: "13px", color: "#666" }}>
                      ({e.subType})
                    </span>
                  )}
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "#444",
                    marginTop: "4px",
                  }}
                >
                  <strong>{e.customerName || "—"}</strong>
                  {e.locationName ? ` · ${e.locationName}` : ""}
                </div>
                {e.statusNote && (
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#444",
                      fontStyle: "italic",
                      marginTop: "6px",
                    }}
                  >
                    "{e.statusNote}"
                  </div>
                )}
                {e.statusChangedAt && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "4px",
                    }}
                  >
                    Set by{" "}
                    {e.statusChangedByName || e.statusChangedBy || "—"} on{" "}
                    {formatDateTime(e.statusChangedAt)}
                  </div>
                )}
              </li>
            ))}
        </ul>
      )}
    </>
  );
}
